

import React, { Component } from 'react'
import './ProjectInfo.css'

export default class ProjectInfo extends Component {
  render() {
    return (
      <div className ="project">
          <h2>Project</h2>
          
       
          <h3> Our ambition</h3>
          <p> Our project includes three ambitious peoples: two back-end developers and one front-end.
            With our ambition, We want to build a place for all bikers in the world to follow their 
            ambitions and create a community for them. To do so, we are building an NFT collections and afterward 
            a market place where bikers can mint, trade their NFT collections. After,we can operate the competititions 
            between bikers all over the world. </p>
          
          </div>
    )
  }
}
